export default __webpack_public_path__ + "static/media/inline4.b7d86991.jpg";